import React, {useContext} from 'react';

import HtmlText from '~/src/components/htmlText/HtmlText';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames, getFormatClassNames} from '~/src/utilities/helpers/css';

import css from './Quote.module.scss';

const Quote = ({quote, author = '', format}) => {
    const {siteArea} = useContext(SettingsContext);
    const quoteClasses = classNames(css, 'quote', siteArea, getFormatClassNames(format));
    const authorClasses = classNames(css, 'quoteAuthor', siteArea, getFormatClassNames(format));

    return (
        <figure>
            <blockquote className={quoteClasses}>
                <p className={css.quoteText}>
                    <HtmlText as="span" htmlText={quote} />
                </p>
            </blockquote>
            {author && (
                <figcaption>
                    <cite className={authorClasses}>{author}</cite>
                </figcaption>
            )}
        </figure>
    );
};

export default Quote;
